import { Injectable } from '@angular/core'
import {
  CreateFilePieceListsResult,
  CreateFilesParamsV2,
  CreateFilesResultV2,
} from '../../../generated/efp-api'
import { CreateFileArticlesParams } from '../../../generated/efp-api/models'

@Injectable()
export abstract class PlanFileDao {
  protected constructor() {}

  abstract createPlanFiles(planId: number, body: CreateFilesParamsV2): Promise<CreateFilesResultV2>

  abstract createPlanPieceLists(
    planId: number,
    body: CreateFileArticlesParams
  ): Promise<CreateFilePieceListsResult>
}
